import { createReducer } from '@reduxjs/toolkit'
import { types, getNodeKey } from 'actions/manual_pages/admin_actions'
import {
  addNodeToTree, updateNodeInTree, deleteNodeFromTree, selectPageForEdit,
  resetFormData , callWithCompletedPagePath
} from './helpers'

export default createReducer({}, (builder) => {
  builder
    .addCase(types.INIT, (state, action) => {
      state.treeData = action.treeData
    })
    .addCase(types.UPDATE_TREE_ITEMS, (state, action) => {
      resetFormData(state)
      state.treeData = action.treeData
    })
    .addCase(types.NEW, (state, action) => {
      state.page = action.page
    })
    .addCase(types.CREATE, (state, action) => {
      resetFormData(state)
      addNodeToTree(state, action.data.page)
    })
    .addCase(types.EDIT, (state, action) => {
      callWithCompletedPagePath(action.data.page, (page) => {
        updateNodeInTree(state, page)
        selectPageForEdit(state, page)
      })
    })
    .addCase(types.SOFT_UPDATE, (state, action) => {
      state.page = action.data
    })
    .addCase(types.UPDATE, (state, action) => {
      callWithCompletedPagePath(action.data.page, (page) => {
        updateNodeInTree(state, page)
        resetFormData(state)
      })
    })
    .addCase(types.CHANGE_POSITION, (state, action) => {
      callWithCompletedPagePath(action.data.page, (page) => {
        updateNodeInTree(state, page)
        resetFormData(state)
      })
    })
    .addCase(types.DELETE, (state, action) => {
      deleteNodeFromTree(state, action)
    })
})
